const CONSTANTS = {
  D_LIBRARY_SUBSCRIPTION_PAYMENT: `${process.env.REACT_APP_DONGA_STORE}/product/gzs7BGyv`,
}

export default CONSTANTS